import type { LoaderFunctionArgs } from '~/types/route-args';
import { LoginPage } from '@modules/user';
import { redirect } from 'react-router';
import {
    getAuthenticatedLoginRedirectUrl,
    type APHandle,
} from '~/modules/root';
import { getSession } from '~/modules/root/util/session.server';
import { createOGTags, getCanonicalHreflang, mergeMeta } from '~/modules/seo';
import { redirectBack } from 'remix-utils';

export const meta = mergeMeta<typeof loader>(
    () => {
        return [];
    },
    (props) => {
        const title = 'Login to ArchiPro';
        return [
            {
                title,
                ...getCanonicalHreflang(props),
                ...createOGTags({
                    meta: props,
                    title,
                }),
            },
        ];
    },
);

export const shouldRevalidate = () => {
    return false;
};

export const loader = async (args: LoaderFunctionArgs) => {
    const { context, request } = args;
    const { user } = context;

    const session = await getSession(request);

    if (user.__typename === 'Me') {
        session.flashToastMessage({
            type: 'notification',
            message: 'You are already logged in',
        });
        const url = new URL(request.url);
        const redirectUrl = getAuthenticatedLoginRedirectUrl(
            url.searchParams.get('redirect'),
        );

        if (redirectUrl) {
            throw redirect(redirectUrl, {
                headers: await session.getHeaders(),
            });
        }
        if (url.pathname === '/login' || url.pathname === '/login-test') {
            throw redirect('/', { headers: await session.getHeaders() });
        }
        throw redirectBack(request, {
            fallback: '/',
            headers: await session.getHeaders(),
        });
    }
    return {
        pageTheme: 'none',
    };
};

export const handle: APHandle = {
    hideTopNavigation: {
        desktop: true,
        tablet: true,
        mobile: true,
    },
    hideFooter: {
        desktop: true,
        tablet: true,
        mobile: true,
    },
    isChatBoxesDisabled: true,
};

export default LoginPage;
